<div id="config-download-excel-container">
  <p class="subheading-01-semi-bold">Año</p>
  <div id="dropdown">
    <qr-dropdown
      [config]="this.dropdownYears"
      (change)="dropdownYearsChange($event)"
    ></qr-dropdown>
  </div>
</div>
